export default __webpack_public_path__ + "static/media/avatar_5_1.9c240c8e.png";